<template>
  <div>
    <h5 v-html="$t('filter.titles.' + key)" />
    <b-input-group>
      <b-input-group-text>
        <font-awesome-icon :icon="icon" />
      </b-input-group-text>
      <multiselect
        class="custom-select"
        v-model="selected"
        :options="markets"
        :multiple="false"
        :placeholder="$t(tKey + 'placeholder')"
        :closeOnSelect="false"
        :allowEmpty="false"
        :searchable="false"
        :group-select="true"
        selectedLabel=""
        label="Text"
        track-by="Value"
        @input="transmitNewValue()"
        :disabled="active"
      >
        <template slot="selection" slot-scope="{ values }">
          <div v-if="values.length">
            <small
              class="multiselect__single"
              v-if="values.length > 1"
              v-html="
                `${values.length} ${$tc(tKey + 'selected', values.length)}`
              "
            />
            <small class="multiselect__single" v-else v-html="values[0].Text" />
          </div>
        </template>
      </multiselect>
    </b-input-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    default: { type: String, default: "0" },
    propKey: { type: String, default: null },
    active: { type: Boolean, default: false },
    multiple: {type: Boolean, default: true }
  },
  data() {
    return {
      tKey: "filter.markets.",
      selected: null,
      icon: "globe",
      key: "markets",
    };
  },
  created() {
    this.getDefaultMarket();
    this.key = this.propKey ? this.propKey : this.key;
    this.transmitNewValue();
  },
  computed: {
    ...mapGetters("markets", ["markets"]),
  },
  methods: {
    getDefaultMarket() {
      this.selected =
        this.default == "0"
          ? this.markets.filter(
              (country) => country.Value == "0"
            )
          : this.markets.filter(
              (country) => country.Value == this.default
            )[0];
    },
    transmitNewValue() {
      //if(!this.selected.length) this.getDefaultRegion()
      this.$emit("transmit", this.selected, this.key);
    },
  },
};
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect {
  min-height: 0 !important;
  box-sizing: border-box !important;
}
.multiselect__placeholder,
.multiselect__single {
  margin: 0 !important;
}
.multiselect__tags {
  border: none !important;
  min-height: 0 !important;
  padding: 0 !important;
}
.multiselect__select {
  display: none !important;
}
.multiselect__content-wrapper {
  /* width */
  &::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px lightgray;
    border-radius: 0px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: $colorbase-light;
    border-radius: 10px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: $colorbase;
  }
}
</style>
